import React, { useCallback } from 'react';

import { SortEnum } from 'src/queries/__global_generated__/globalTypes';

import { PageInfo } from './ProductListQueryProvider';
import { ToolbarLayout } from './ToolbarLayout';

export enum SortValues {
    Relevance = 'relevance',
    PriceAsc = 'price-asc',
    PriceDesc = 'price-desc',
    NameAsc = 'name-asc',
    NameDesc = 'name-desc',
    Bestsellers = 'Bestsellers',
}

type ToolbarProps = {
    clearSort();
    currentFilters: React.ReactNode;
    initial: SortValues | undefined;
    loading: boolean;
    pageInfo: PageInfo;
    setSortOrder(value, order: SortEnum);
    totalSelections: number;
};

const sortOptions = [
    {
        value: SortValues.Bestsellers,
        label: 'Bestsellers',
    },
    {
        value: SortValues.Relevance,
        label: 'New In',
    },
    {
        value: SortValues.PriceDesc,
        label: 'Price (High - Low)',
    },
    {
        value: SortValues.PriceAsc,
        label: 'Price (Low - High)',
    },
    {
        value: SortValues.NameAsc,
        label: 'Name (A - Z)',
    },
    {
        value: SortValues.NameDesc,
        label: 'Name (Z - A)',
    },
];

export const Toolbar: React.FunctionComponent<ToolbarProps> = React.memo((props) => {
    const { setSortOrder, clearSort, pageInfo } = props;

    const onChange = useCallback(
        (e) => {
            switch (e.target.value) {
                case SortValues.NameAsc:
                    return setSortOrder('name', SortEnum.ASC);

                case SortValues.NameDesc:
                    return setSortOrder('name', SortEnum.DESC);

                case SortValues.PriceAsc:
                    return setSortOrder('price', SortEnum.ASC);

                case SortValues.PriceDesc:
                    return setSortOrder('price', SortEnum.DESC);

                case SortValues.Bestsellers:
                    return setSortOrder('bestsellers', SortEnum.ASC);

                case SortValues.Relevance:
                    return clearSort();
            }
        },
        [clearSort, setSortOrder],
    );

    return (
        <ToolbarLayout
            totalSelections={props.totalSelections}
            loading={props.loading}
            sorter={
                <select onChange={onChange} title="Sorter" data-test-id="category-sort">
                    <option disabled={true} selected={true}>
                        Sort By:
                    </option>

                    {sortOptions.map((option) => {
                        return (
                            <option key={option.label} title={option.label} value={option.value}>
                                {option.label}
                            </option>
                        );
                    })}
                </select>
            }
            currentFilters={props.currentFilters}
            stats={
                <span data-test-id="Toolbar_PageCount">
                    {pageInfo.total_count} products found — Page {pageInfo.current_page} of {pageInfo.total_pages}
                </span>
            }
        />
    );
});
